//
//  BloodPressureRegistration.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { ReactElement } from "react";
import { Box, Typography, Alert, Button } from "@mui/material";
import { ProgressBar, ProgressStatus } from "./component/ProgressBar";
import { FooterWithCorporateLogo } from "./component/FooterWithCorporateLogo";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useBloodPressureRegistrationViewModel } from "./hooks/BloodPressureRegistration.viewModel";

const BloodPressureRegistration = (): ReactElement => {
  const viewModel = useBloodPressureRegistrationViewModel();

  const {
    message,
    errorMessage,
    alertMessage,
    showAlert,
    severity,
    paused,
    progressStatus,
  } = viewModel.props;

  const {
    handleScanQrCode,
    handleClickRestart,
    handleCloseError,
    handleCloseAlert,
  } = viewModel.handlers;

  return (
    <Box style={{ height: "100%" }}>
      <ProgressBar status={progressStatus.current}></ProgressBar>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        {progressStatus.current === ProgressStatus.bloodPressureScaned && (
          <Typography variant="h4">読み込み中...</Typography>
        )}
        {progressStatus.current !== ProgressStatus.bloodPressureScaned && (
          <>
            <Typography variant="h5" sx={{ pb: 2, pt: 2 }}>
              {message}
            </Typography>
            <Scanner
              components={{ torch: false }}
              styles={{
                container: {
                  width: "30%",
                  minHeight: 400,
                },
                video: {},
              }}
              // NOTE: History -> Registrationに遷移したときにOverConstrainedエラーが出ることがあるのでリロードする
              onError={(_e) => {
                window.location.reload();
              }}
              allowMultiple
              paused={paused}
              onScan={handleScanQrCode}
            />
          </>
        )}
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100px",
        }}
      >
        {showAlert && (
          <Alert
            severity={severity}
            sx={{ fontSize: "1.2rem" }}
            onClose={handleCloseAlert}
          >
            {alertMessage}
          </Alert>
        )}
        {errorMessage && (
          <Alert
            severity="error"
            sx={{ fontSize: "1.2rem" }}
            onClose={handleCloseError}
          >
            {errorMessage}
          </Alert>
        )}
      </Box>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Button onClick={handleClickRestart} variant="contained" sx={{ mt: 2 }}>
          はじめからやり直す
        </Button>
      </Box>
      <FooterWithCorporateLogo />
    </Box>
  );
};

export default BloodPressureRegistration;
